import Emitter from '@/utils/Emitter';
import { debounce, isEmpty, join, map, size, split } from 'lodash';
import React, { useEffect, useMemo } from 'react';


function UpFilter({ filterObj, category }) {

  const { filterKeys } = filterObj;

  const handleChange = useMemo(() =>
    debounce((val) => {
      let tmpFilter = { ...filterObj };
      tmpFilter.search_txt = val;
      tmpFilter.offset = 0;
      Emitter.emit("SET_PRODUCT_FILER", tmpFilter);
    }, 400)
    , [filterObj]);


  const handleClearFilter = (indx) => {
    let fObj = { ...filterObj };
    let fKeys = [...fObj.filterKeys];
    let tabObj = fKeys[indx];

    if (tabObj.type === "supplier_country") {

      let cnty = split(fObj.supplier_country, ",").filter(Boolean);
      cnty = cnty.filter(id => id !== String(tabObj.id));
      fObj.supplier_country = join(cnty, ",");
    }

    if (tabObj.type === "business_type") {

      let bType = split(fObj.business_type, ",").filter(Boolean);
      bType = bType.filter(bt => bt !== tabObj.label);
      fObj.business_type = join(bType, ",");
    }


    fKeys.splice(indx, 1);
    fObj.filterKeys = fKeys;
    fObj.offset = 0;
    
    Emitter.emit("SET_PRODUCT_FILER", fObj);
  }

  const handleClearAll = () => {
    const fObj = {
      ...filterObj,
      business_type: "",
      supplier_country: "",
      filterKeys: [],
      offset: 0,
    };

    Emitter.emit("SET_PRODUCT_FILER", fObj);
  };

  useEffect(() => {
    //Emitter.on("")
  }, []);

  return (
    <>
      <div className='up-filter-wrape'>
        <div className="head-text button-head">
          <h2 className="head">{!isEmpty(category) ? category : ""}</h2>

          <div className="btn-wrape hint-search">
            <div className='search-wrape'>
              <input type='text' placeholder='Search By Product Name, HSN Code' onChange={(e) => handleChange(e.target.value)} />
              {/* <input type='text' placeholder='Search By' onChange={(e) => handleChange(e.target.value)} /> */}
              <i className='sprite search'></i>
            </div>
            {/* <span className='hint'><b>Ex.:</b> Product Name, HSN Code</span> */}
          </div>
        </div>


        <div className={`${size(filterKeys) > 0 ? 'filter-tag-wrape' : ''}`}>
          {
            filterKeys && map(filterKeys, (val, indx) => {
              return (<div className='tag-btn' key={`f_${indx}`}>
                <span>{val.label}</span>
                <div title={val.label} className='close' onClick={() => handleClearFilter(indx)}></div>
              </div>)
            })
          }
          {
            size(filterKeys) > 0 && <div className='btn outline' title='Clear Filters' onClick={handleClearAll}>Clear Filters</div>
          }

        </div>
      </div>
    </>
  )
}

export default UpFilter
